import React, { useState } from "react";
import { Modal, Button, Image, Badge } from "react-bootstrap";
import UploadIcon from "../../assets/images/Folder.svg";
import { FileUploader } from "react-drag-drop-files";
import {
  fileSizeValidation,
  fileTypeValidation,
  getItem,
} from "../../utils/Functions";
import {
  uploadOfferedCandidateProfileResume,
  uploadTemporaryFile,
} from "../../pages/Profile/actions";
import { useDispatch } from "react-redux";

const DocumentUpload = ({
  resumeDetails,
  setModalShow,
  modalShow,
  isGuest,
  type,
  photo,
  setPhoto,
  resume,
  setResume,
  setPhotoFormData,
  setResumeFormData,
}) => {
  let candidateId = JSON.parse(getItem("User"))._id;
  const dispatch = useDispatch();
  const [resumeFileName, setResumeFileName] = useState("");
  const [resumeFile, setResumeFile] = useState("");
  const [isFileUploading, setIsFileUploading] = useState(false);
  const resumeFileTypes = [
    "PDF",
    "DOC",
    "DOCX",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "JPG",
    "JPEG",
  ];
  const photoFileTypes = ["JPG", "JPEG", "PNG", "GIF", "BMP", "SVG", "WEBP"];
  const handleResumeChange = (file, event) => {
    setResumeFileName(file.name);
    let formData = new FormData();
    formData.append("file", file);
    formData.append("userId", candidateId);
    formData.append("type", type === "profile" ? "photo" : "resume");
    setResumeFile(formData);
  };
  const handleFileSubmit = async () => {
    setIsFileUploading(true);
    if (resumeFile !== "" && !isGuest) {
      dispatch(
        uploadOfferedCandidateProfileResume(
          resumeFile,
          candidateId,
          resumeDetails.resume,
          "resume",
          true,
          () => {
            setIsFileUploading(false);
            setModalShow(false);
            setResumeFile("");
            setResumeFileName("");
          }
        )
      );
    } else if (resumeFile !== "" && isGuest) {
      dispatch(
        uploadTemporaryFile(
          resumeFile,
          type === "profile" ? photo : resume,
          (response) => {
            setIsFileUploading(false);
            setModalShow(false);
            setResumeFile("");
            setResumeFileName("");
            type === "profile"
              ? setPhoto(response.data.data)
              : setResume(response.data.data);
            type === "profile"
              ? setPhotoFormData(resumeFile)
              : setResumeFormData(resumeFile);
            type === "profile"
              ? localStorage.setItem("photo", response.data.data)
              : localStorage.setItem("resume", response.data.data);
          }
        )
      );
    }
  };
  return (
    <Modal show={modalShow} centered id="showpreview">
      <Modal.Header>
        <Modal.Title>Upload CV</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="document-file-uploader upload-candidate-resume h-auto">
          <div className="document-upload">
            <div className={"document-uploader-block"}>
              <div className="upload-icon-title">
                <Image src={UploadIcon} alt="Upload-icon" />
                <p className="upload-icon-title-text mt-4 mb-0">
                  Upload or Drag your {type === "profile" ? "photo" : "resume"}{" "}
                  here
                </p>
                <span className="text-danger small">
                  Recommended file size upto 5 MB
                </span>
                <p className="or-text position-relative mt-4">OR</p>

                <Button type="button" variant="gray mb-2">
                  Browse Files
                </Button>
                <p>{resumeFileName}</p>
              </div>
              <FileUploader
                name="file"
                types={type === "profile" ? photoFileTypes : resumeFileTypes}
                handleChange={handleResumeChange}
                maxSize={5}
                onSizeError={fileSizeValidation}
                onTypeError={fileTypeValidation}
              />
            </div>
            <div className="upload-file-extensions">
              {type === "resume" &&
                ["PDF", "DOC", "DOCX"].map((item) => (
                  <Badge bg="primary" className="badge-custom">
                    {item}
                  </Badge>
                ))}
              {type === "profile" &&
                ["JPG", "JPEG", "PNG", "BMP", "SVG", "WEBP"].map((item) => (
                  <Badge bg="primary" className="badge-custom">
                    {item}
                  </Badge>
                ))}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setModalShow(false)}
          className="me-2"
        >
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleFileSubmit}
          disabled={resumeFile !== "" ? false : true}
        >
          Upload
          {isFileUploading && (
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DocumentUpload;
